__turbopack_context__.v({
  "guide": "Guide-module-scss-module__Zhk9la__guide",
  "guide__isCard": "Guide-module-scss-module__Zhk9la__guide__isCard",
});
